var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{class:[_vm.$style.wrapper, _vm.overlay && _vm.$style.overlay, _vm.transparent && _vm.$style.transparent]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }